"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a, _b, _c, _d, _e, _f, _g, _h;
Object.defineProperty(exports, "__esModule", { value: true });
exports.typographyMixins = exports.thicknessScheme = void 0;
var system_1 = require("../system");
var YS_Text_Bold_woff_1 = "https://yastatic.net/s3/home/fonts/ys/1/text-bold.woff";
var YS_Text_Bold_woff2_1 = "https://yastatic.net/s3/home/fonts/ys/1/text-bold.woff2";
var YS_Text_Light_woff_1 = "https://yastatic.net/s3/home/fonts/ys/1/text-light.woff";
var YS_Text_Light_woff2_1 = "https://yastatic.net/s3/home/fonts/ys/1/text-light.woff2";
var YS_Text_Medium_woff_1 = "https://yastatic.net/s3/home/fonts/ys/1/text-medium.woff";
var YS_Text_Medium_woff2_1 = "https://yastatic.net/s3/home/fonts/ys/1/text-medium.woff2";
var YS_Text_Regular_woff_1 = "https://yastatic.net/s3/home/fonts/ys/1/text-regular.woff";
var YS_Text_Regular_woff2_1 = "https://yastatic.net/s3/home/fonts/ys/1/text-regular.woff2";
var fontFamily = 'YS Text';
exports.thicknessScheme = {
    light: 300,
    regular: 400,
    medium: 500,
    bold: 700,
};
var normalYS = {
    fontFamily: fontFamily,
    fontWeight: exports.thicknessScheme.regular,
    fontStretch: 'normal',
    src: "url('".concat(YS_Text_Regular_woff2_1, "') format('woff2'), url('").concat(YS_Text_Regular_woff_1, "') format('woff')"),
};
var boldYS = __assign(__assign({}, normalYS), { fontWeight: exports.thicknessScheme.bold, src: "url('".concat(YS_Text_Bold_woff2_1, "') format('woff2'), url('").concat(YS_Text_Bold_woff_1, "') format('woff')") });
var mediumYS = __assign(__assign({}, normalYS), { fontWeight: exports.thicknessScheme.medium, src: "url('".concat(YS_Text_Medium_woff2_1, "') format('woff2'), url('").concat(YS_Text_Medium_woff_1, "') format('woff')") });
var lightYS = __assign(__assign({}, normalYS), { fontWeight: exports.thicknessScheme.light, src: "url('".concat(YS_Text_Light_woff2_1, "') format('woff2'), url('").concat(YS_Text_Light_woff_1, "') format('woff')") });
var fontSizeMap = (_a = {},
    _a[system_1.BGTypographyVariants.Header] = 48,
    _a[system_1.BGTypographyVariants.Title1] = 40,
    _a[system_1.BGTypographyVariants.Title2] = 32,
    _a[system_1.BGTypographyVariants.Title3] = 28,
    _a[system_1.BGTypographyVariants.Title4] = 24,
    _a[system_1.BGTypographyVariants.Body1] = 20,
    _a[system_1.BGTypographyVariants.Body2] = 16,
    _a[system_1.BGTypographyVariants.Caption1] = 13,
    _a[system_1.BGTypographyVariants.Caption2] = 11,
    _a);
var fontWeightMap = {
    regular: exports.thicknessScheme.regular,
    light: exports.thicknessScheme.light,
    medium: exports.thicknessScheme.medium,
    bold: exports.thicknessScheme.bold,
};
var lineHeightsMap = {
    normal: (_b = {},
        _b[system_1.BGTypographyVariants.Header] = '46px',
        _b[system_1.BGTypographyVariants.Title1] = '42px',
        _b[system_1.BGTypographyVariants.Title2] = '35px',
        _b[system_1.BGTypographyVariants.Title3] = '31px',
        _b[system_1.BGTypographyVariants.Title4] = '27px',
        _b[system_1.BGTypographyVariants.Body1] = '23px',
        _b[system_1.BGTypographyVariants.Body2] = '19px',
        _b[system_1.BGTypographyVariants.Caption1] = '15px',
        _b[system_1.BGTypographyVariants.Caption2] = '13px',
        _b),
    tight: (_c = {},
        _c[system_1.BGTypographyVariants.Header] = '40px',
        _c[system_1.BGTypographyVariants.Title1] = '34px',
        _c[system_1.BGTypographyVariants.Title2] = '28px',
        _c[system_1.BGTypographyVariants.Title3] = '24px',
        _c[system_1.BGTypographyVariants.Title4] = '21px',
        _c[system_1.BGTypographyVariants.Body1] = '20px',
        _c[system_1.BGTypographyVariants.Body2] = '17px',
        _c[system_1.BGTypographyVariants.Caption1] = '14px',
        _c[system_1.BGTypographyVariants.Caption2] = '12px',
        _c),
    loose: (_d = {},
        _d[system_1.BGTypographyVariants.Header] = '50px',
        _d[system_1.BGTypographyVariants.Title1] = '44px',
        _d[system_1.BGTypographyVariants.Title2] = '37px',
        _d[system_1.BGTypographyVariants.Title3] = '34px',
        _d[system_1.BGTypographyVariants.Title4] = '30px',
        _d[system_1.BGTypographyVariants.Body1] = '26px',
        _d[system_1.BGTypographyVariants.Body2] = '21px',
        _d[system_1.BGTypographyVariants.Caption1] = '17px',
        _d[system_1.BGTypographyVariants.Caption2] = '15px',
        _d),
};
var letterSpacingMap = {
    regular: (_e = {},
        _e[system_1.BGTypographyVariants.Header] = '-0.03em',
        _e[system_1.BGTypographyVariants.Title1] = '-0.025em',
        _e[system_1.BGTypographyVariants.Title2] = '-0.025em',
        _e[system_1.BGTypographyVariants.Title3] = '-0.015em',
        _e[system_1.BGTypographyVariants.Title4] = '-0.01em',
        _e[system_1.BGTypographyVariants.Body1] = '-0.01em',
        _e[system_1.BGTypographyVariants.Body2] = 'normal',
        _e[system_1.BGTypographyVariants.Caption1] = 'normal',
        _e[system_1.BGTypographyVariants.Caption2] = '0.01em',
        _e),
    light: (_f = {},
        _f[system_1.BGTypographyVariants.Header] = '-0.03em',
        _f[system_1.BGTypographyVariants.Title1] = '-0.025em',
        _f[system_1.BGTypographyVariants.Title2] = '-0.025em',
        _f[system_1.BGTypographyVariants.Title3] = '-0.015em',
        _f[system_1.BGTypographyVariants.Title4] = '-0.01em',
        _f[system_1.BGTypographyVariants.Body1] = '-0.01em',
        _f[system_1.BGTypographyVariants.Body2] = 'normal',
        _f[system_1.BGTypographyVariants.Caption1] = 'normal',
        _f[system_1.BGTypographyVariants.Caption2] = '0.01em',
        _f),
    medium: (_g = {},
        _g[system_1.BGTypographyVariants.Header] = '-0.02em',
        _g[system_1.BGTypographyVariants.Title1] = '-0.02em',
        _g[system_1.BGTypographyVariants.Title2] = '-0.02em',
        _g[system_1.BGTypographyVariants.Title3] = '-0.015em',
        _g[system_1.BGTypographyVariants.Title4] = '-0.01em',
        _g[system_1.BGTypographyVariants.Body1] = '-0.01em',
        _g[system_1.BGTypographyVariants.Body2] = '-0.005em',
        _g[system_1.BGTypographyVariants.Caption1] = 'normal',
        _g[system_1.BGTypographyVariants.Caption2] = '0.01em',
        _g),
    bold: (_h = {},
        _h[system_1.BGTypographyVariants.Header] = '-0.02em',
        _h[system_1.BGTypographyVariants.Title1] = '-0.02em',
        _h[system_1.BGTypographyVariants.Title2] = '-0.02em',
        _h[system_1.BGTypographyVariants.Title3] = '-0.015em',
        _h[system_1.BGTypographyVariants.Title4] = '-0.01em',
        _h[system_1.BGTypographyVariants.Body1] = '-0.01em',
        _h[system_1.BGTypographyVariants.Body2] = '-0.005em',
        _h[system_1.BGTypographyVariants.Caption1] = 'normal',
        _h[system_1.BGTypographyVariants.Caption2] = '0.01em',
        _h),
};
var typographyMixins = function (colors) {
    var _a;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var src = normalYS.src, rest = __rest(normalYS, ["src"]);
    var commonStyles = __assign(__assign({}, rest), { color: colors.system.TextMain });
    function mixin(preset) {
        return __assign(__assign({}, commonStyles), { fontSize: fontSizeMap[preset.typographyVariant], fontWeight: fontWeightMap[preset.typographyWeight || 'regular'], lineHeight: lineHeightsMap[preset.typographyGroup || 'tight'][preset.typographyVariant], letterSpacing: letterSpacingMap[preset.typographyWeight || 'regular'][preset.typographyVariant] });
    }
    return _a = {
            fontFaces: {
                '@global': {
                    '@font-face': [normalYS, mediumYS, lightYS, boldYS],
                },
            },
            createStyles: mixin
        },
        // обратная совместимость
        _a[system_1.TypographyVariants.Header] = mixin({
            typographyVariant: system_1.BGTypographyVariants.Title1,
            typographyGroup: 'loose',
            typographyWeight: 'light',
        }),
        _a[system_1.TypographyVariants.LargeTitle] = mixin({
            typographyVariant: system_1.BGTypographyVariants.Title4,
            typographyGroup: 'normal',
            typographyWeight: 'bold',
        }),
        _a[system_1.TypographyVariants.Number] = mixin({
            typographyVariant: system_1.BGTypographyVariants.Title4,
            typographyGroup: 'normal',
            typographyWeight: 'light',
        }),
        _a[system_1.TypographyVariants.Title] = mixin({
            typographyVariant: system_1.BGTypographyVariants.Body1,
            typographyGroup: 'normal',
            typographyWeight: 'medium',
        }),
        _a[system_1.TypographyVariants.Headline1] = mixin({
            typographyVariant: system_1.BGTypographyVariants.Body2,
            typographyGroup: 'loose',
            typographyWeight: 'medium',
        }),
        _a[system_1.TypographyVariants.Headline2] = mixin({
            typographyVariant: system_1.BGTypographyVariants.Caption1,
            typographyGroup: 'loose',
            typographyWeight: 'medium',
        }),
        _a[system_1.TypographyVariants.Body] = mixin({
            typographyVariant: system_1.BGTypographyVariants.Caption1,
            typographyGroup: 'loose',
            typographyWeight: 'regular',
        }),
        _a[system_1.TypographyVariants.Subhead] = mixin({
            typographyVariant: system_1.BGTypographyVariants.Caption1,
            typographyGroup: 'tight',
            typographyWeight: 'medium',
        }),
        _a[system_1.TypographyVariants.Caption] = mixin({
            typographyVariant: system_1.BGTypographyVariants.Caption2,
            typographyGroup: 'loose',
            typographyWeight: 'regular',
        }),
        _a;
};
exports.typographyMixins = typographyMixins;
